export default "__VITE_ASSET__DNinlLXU__"